<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tbl-scroll-host">
            <el-table :data="users" v-loading="listLoading" class="compact-table" style="width: 100%;" height="100%">
                <el-table-column prop="Name" label="显示名称" min-width="100"></el-table-column>
                <el-table-column label="教师" min-width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.TeacherName" type="primary" size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DepartmentName" label="学校" min-width="120"></el-table-column>
                <el-table-column label="校区范围" min-width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.CampusId === 0 || scope.row.CampusId === '0'" size="mini" type="info" effect="plain">全部校区</el-tag>
                        <el-tag v-else-if="scope.row.CampusName" size="mini" type="primary" effect="plain">{{ scope.row.CampusName }}</el-tag>
                        <el-tag v-else-if="getCampusName(scope.row.CampusId) && getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
                        <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Enabled" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
                            {{ scope.row.Enabled ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="170" align="center"></el-table-column>
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="42%" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
                    <!-- 去除所属学校选择，直接关联页面统一选中的学校 ID -->
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请先选择校区" style="width: 100%"
                            @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="教职工" prop="TeacherId">
                        <div class="ps-pick-summary">
                            <span v-if="editForm.TeacherId">
                                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
                            </span>
                            <span v-else class="muted-text">请选择一名教职工</span>
                            <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
                            <el-button v-if="editForm.TeacherId" type="text" size="mini" @click="clearTeacherPick">清空</el-button>
                        </div>
                        <div class="form-tip">从通讯录选择，仅绑定一人</div>
                    </el-form-item>
                    <el-form-item label="显示名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="100" placeholder="可与教师姓名一致"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-switch v-model="editForm.Enabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="personPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="editForm.DepartmentId || DepartmentId"
                :value="editForm.TeacherId"
                :label="selectedPersonLabel"
                @confirm="onPersonPicked"
            />
        </section>
    </section>
</template>

<script>
import { getMoralMallAdminListPage, addMoralMallAdmin, editMoralMallAdmin, removeMoralMallAdmin } from '../../api/modules/moral-education';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';
import { normalizeDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';

/** 德育商城管理员维护（参考值周人员、荣誉采集人员配置页）。创建于 2026-04-15 */
export default {
    name: "MoralMallAdmin",
    components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
    data() {
        return {
            filters: {
                campusId: null,
                name: ''
            },
            campusOptions: [],
            searchList: [
                { label: '姓名', key: 'name' },
                {
                    label: '选择校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    options: [],
                },
            ],
            users: [],
            total: 0,
            page: 1,
            PageSize: 10,
            listLoading: false,
            buttonList: [],
            DepartmentId: 0,
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            personPickerVisible: false,
            selectedPersonLabel: '',
            editFormRules: {
                CampusId: [
                    { required: true, message: '请选择所属校区', trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            if (!normalizeDeptId(value)) {
                                callback(new Error('请选择具体校区'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                Name: [{ required: true, message: "请输入显示名称", trigger: "blur" }],
                TeacherId: [{
                    validator: (rule, value, callback) => {
                        if (!value || Number(value) <= 0) {
                            callback(new Error('请选择教职工'));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                }],
            },
            editForm: {
                Id: 0,
                Name: '',
                DepartmentId: 0,
                CampusId: null,
                TeacherId: null,
                Enabled: true,
                Remark: '',
            },
        };
    },
    methods: {
        treeNodeClick(data) {
            this.DepartmentId = treeNodeDeptId(data);
            this.clearCampusFilter();
            if (this.positiveDeptId(this.DepartmentId)) {
                this.loadCampusOptions(this.DepartmentId);
            }
            this.handleQuery();
        },
        /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
        clearCampusFilter() {
            this.filters = { ...(this.filters || {}), campusId: null };
            this.campusOptions = [];
            const campusSearch = this.searchList.find((e) => e.key === 'campusId');
            if (campusSearch) campusSearch.options = [];
            if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
            }
        },
        handleQuery() {
            this.page = 1;
            this.getUsers();
        },
        getUsers() {
            const para = {
                page: this.page,
                intPageSize: this.PageSize,
                departmentId: this.DepartmentId,
                name: this.filters.name || '',
            };
            if (this.filters.campusId != null && this.filters.campusId !== '' && this.filters.campusId !== undefined) {
                para.campusId = this.filters.campusId;
            }
            this.listLoading = true;
            getMoralMallAdminListPage(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.users = res.data.response.data || [];
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.getUsers();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = Object.assign({}, this.filters, item.search);
            } else {
                this.filters = Object.assign({}, this.filters, { name: item.search });
            }
            this[item.Func].apply(this, item);
        },
        handleAdd() {
            if (!this.positiveDeptId(this.DepartmentId)) {
                this.$message.warning('请先在左侧选择具体的学校机构！');
                return;
            }
            this.dialogTitle = '新增德育商城管理员';
            this.editFormVisible = true;
            this.selectedPersonLabel = '';
            const presetCampus = normalizeDeptId(this.filters.campusId) || null;
            this.editForm = {
                Id: 0,
                Name: '',
                DepartmentId: this.DepartmentId,
                CampusId: presetCampus,
                TeacherId: null,
                Enabled: true,
                Remark: '',
            };
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
            this.loadCampusOptions(this.DepartmentId);
        },
        handleEdit(row) {
            this.dialogTitle = '编辑德育商城管理员';
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);
            this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
            this.selectedPersonLabel = row.TeacherName || row.Name || '';
            if (this.editForm.CampusId === 0 || this.editForm.CampusId === '0') {
                this.$set(this.editForm, 'CampusId', null);
            }
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
            const schoolId = this.positiveDeptId(this.editForm.DepartmentId);
            if (schoolId) {
                this.loadCampusOptions(schoolId);
            }
        },
        handleDel(row) {
            this.$confirm('确认删除该记录吗？', '提示', { type: 'warning' }).then(() => {
                this.listLoading = true;
                removeMoralMallAdmin({ id: row.Id }).then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getUsers();
                    }
                });
            });
        },
        /** 仅接受大于 0 的部门 Id（0 在 JS 中与 || 组合会导致误判） */
        positiveDeptId(v) {
            const id = normalizeDeptId(v);
            return id || null;
        },
        /**
         * 根据学校部门 Id 拉取校区列表。
         */
        loadCampusOptions(deptId) {
            let schoolId = this.positiveDeptId(deptId);
            if (schoolId == null) {
                schoolId = this.positiveDeptId(this.editForm.DepartmentId);
            }
            if (schoolId == null) {
                schoolId = this.positiveDeptId(this.DepartmentId);
            }
            if (!schoolId) {
                this.campusOptions = [];
                const campusSearch = this.searchList.find(e => e.key === 'campusId');
                if (campusSearch) {
                    campusSearch.options = [];
                }
                return;
            }
            getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                if (res.data.success) {
                    this.campusOptions = res.data.response.data || [];
                    const campusSearch = this.searchList.find(e => e.key === 'campusId');
                    if (campusSearch) {
                        campusSearch.options = this.campusOptions.map(e => ({
                            label: e.Name,
                            value: e.Id
                        }));
                    }
                }
            });
        },
        /** 换校区时清空已选教职工（权限范围变更）。创建于 2026-09-23 */
        handleCampusChange() {
            this.clearTeacherPick();
        },
        getCampusName(campusId) {
            if (campusId === 0 || campusId === '0') return '全部校区';
            if (!campusId || !this.campusOptions.length) return '-';
            const campus = this.campusOptions.find(c => c.Id === campusId);
            return campus ? campus.Name : '-';
        },
        /** 打开内部通讯录单选教职工。创建于 2026-09-23 */
        openPersonPicker() {
            const schoolId = this.positiveDeptId(this.editForm.DepartmentId) || this.positiveDeptId(this.DepartmentId);
            if (!schoolId) {
                this.$message.warning('请先在左侧选择学校！');
                return;
            }
            this.personPickerVisible = true;
        },
        clearTeacherPick() {
            this.editForm.TeacherId = null;
            this.selectedPersonLabel = '';
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
            });
        },
        onPersonPicked(person) {
            if (!person) return;
            this.editForm.TeacherId = person.id;
            this.selectedPersonLabel = person.name || '';
            if (person.name) {
                this.editForm.Name = person.name;
                this.$nextTick(() => {
                    if (this.$refs.editForm) {
                        this.$refs.editForm.clearValidate(['Name']);
                        this.$refs.editForm.validateField('Name');
                        this.$refs.editForm.validateField('TeacherId');
                    }
                });
            } else {
                this.$nextTick(() => {
                    if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
                });
            }
        },
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) return;
                this.editLoading = true;
                const para = Object.assign({}, this.editForm);
                const apiCall = para.Id > 0 ? editMoralMallAdmin : addMoralMallAdmin;
                apiCall(para).then((res) => {
                    if (res.data.success) {
                        this.$message({ message: '提交成功', type: 'success' });
                        this.editFormVisible = false;
                        this.getUsers();
                    } else {
                        this.$message.error(res.data.msg || '提交失败');
                    }
                    this.editLoading = false;
                }).catch(() => {
                    this.editLoading = false;
                });
            });
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 });
        }
    },
};
</script>

<style scoped>
.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}
.muted-text {
    color: #94a3b8;
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 6px;
}
</style>
